export default __webpack_public_path__ + "static/media/11-47.ec528732.png";